export enum MessageType {
  MESSAGE = "message",
  INFO = "info",
  FILE = "file",
  FEEDBACK = "feedback",
}

export type Editor = {
  memberId: string;
  username: string;
  name: string;
  createdAt: Date;
  _id: string;
};

export type ChannelInfo = {
  _id: string;
  groupId: string;
  divisionId: string;
  status: string;
  type: string;
  editor: Editor[];
};

export type Receiver = {
  username: string;
  createdAt: Date;
  status: string;
  _id: string;
};

export type Message = {
  _id: string;
  chatChannel: string;
  createdAt: string;
  username: string;
  role: "user" | "csr";
  type?: string;
  message: string;
  deleted: boolean;
  receiver: Receiver[];
};

export type NewMessageInterface = {
  message: string;
  chatChannel: string;
  tempId: string;
  type: MessageType;
  memberDetail?: Record<string, unknown>;
};

export type ChatChannel = {
  channel: ChannelInfo;
  message: Message;
  totalUnreadMessage: number;
};

export type ChatMessage = {
  _id: string;
  chatChannel: string;
  createdAt: string;
  username: string;
  role: "member" | "csr" | "bot";
  type?: string;
  message: string;
  deleted?: boolean;
  receiver?: Receiver[];
};

export type ChannelMessagesPayload = {
  chatChannel: string;
  messageRef1?: string;
  messageRef2?: string;
  order?: number;
};

export type ChannelMessagesResponse = {
  data: ChatMessage[];
  newCount: number;
  oldCount: number;
};

export type MemberTokenParams = {
  group_id: string;
  username: string;
};

export type MemberAccessTokenResponse = {
  accessCode: string;
};

export type ChangeChannelStatus = {
  chatChannel: string;
  status: "queue" | "active" | "paused" | "closed";
};

export type ClientDetails = {
  from_hour: string;
  to_hour: string;
  time_zone: string;
};

export type ChatLiabilityData = {
  chat_liability_alert: string;
  client_details: ClientDetails;
};
